var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "rounded-l"
  }, [_c('v-card-title', {
    staticClass: "primary white--text"
  }, [_vm._v(" " + _vm._s(_vm.location.company_name) + " ")]), _c('v-card-text', {
    staticClass: "pa-4"
  }, [_c('v-list', [_c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-map-marker")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_c('span', [_vm._v(_vm._s(_vm.location.address_line_1)), _c('br')]), _vm.location.address_line_2 ? _c('span', [_vm._v(_vm._s(_vm.location.address_line_2)), _c('br')]) : _vm._e(), _vm.location.address_line_3 ? _c('span', [_vm._v(_vm._s(_vm.location.address_line_3)), _c('br')]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.location.city_locality) + " " + _vm._s(_vm.location.state_province) + " " + _vm._s(_vm.location.postal_code))])])], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-phone")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm.location.phone ? _c('span', [_vm._v(_vm._s(_vm.location.phone))]) : _c('span', {
    staticClass: "font-italic"
  }, [_vm._v("Not recorded")])])], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-email")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm.location.email ? _c('span', [_vm._v(_vm._s(_vm.location.email))]) : _c('span', {
    staticClass: "font-italic"
  }, [_vm._v("Not recorded")])])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }